import { deleteStickyNoteMutation } from '@akin-home/sticky-notes/frontend';
import { useMutation, useQueryClient } from 'react-query';

export const useDeleteStickyNoteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteStickyNoteMutation, {
    onSuccess: (_, params) => {
      queryClient.setQueriesData('sticky-notes', (notes: any) =>
        notes.filter((note: any) => note.id !== params.input?.id)
      );
    },
  });
};

export const useDeleteStickyNote = () => {
  const _delete = useDeleteStickyNoteMutation();

  return (id: string) => _delete.mutateAsync({ input: { id } });
};
